export enum Alignment {
	BIG_ENDIAN,
	LITTLE_ENDIAN
}